
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { Watch } from "vue-property-decorator";
import { AxiosResponse } from "axios";

@Component({
  filters: filters,
})
export default class ModalRequestDemo extends Vue {
  @Action("getSchoolTypes", { namespace: "admin" })
  private getSchoolTypes: any;
  @Action("getCountry", { namespace: "admin" })
  private getCountry: any;
  @Action("getProvince", { namespace: "admin" })
  private getProvince: any;
  @Action("getCity", { namespace: "admin" })
  private getCity: any;
  @Action("addSchoolRequest", { namespace: "school" })
  private addSchoolRequest: any;

  private schoolTypes: Array<any> = [];
  private countries: Array<any> = [];
  private provinces: Array<any> = [];
  private cities: Array<any> = [];
  private name = "";
  private email = "";
  private schoolType: any = null;
  private country: any = null;
  private province: any = null;
  private city: any = null;
  private adminName = "";
  private adminEmail = "";
  private adminPhone = "";
  private adminPosition = "";

  @Watch("country")
  private onCountry() {
    this.provinces = [];
    this.cities = [];
    this.province = null;
    this.city = null;

    if (this.country?.id) {
      this.getProvince({
        params: {
          country: this.country?.id,
        },
        success: (response: AxiosResponse) => {
          this.provinces = response.data.data;
        },
      });
    }
  }
  @Watch("province")
  private onProvince() {
    this.cities = [];
    this.city = null;

    if (this.province?.id) {
      this.getCity({
        params: {
          province: this.province?.id,
        },
        success: (response: AxiosResponse) => {
          this.cities = response.data.data;
        },
      });
    }
  }

  private created() {
    this.getSchoolTypes({
      success: (response: AxiosResponse) => {
        this.schoolTypes = response.data.data;
      },
    });
    this.getCountry({
      success: (response: AxiosResponse) => {
        this.countries = response.data.data;
      },
    });
  }

  private onlyNumber(event: any) {
    let keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode !== 43) {
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    }
  }

  private submit() {
    this.addSchoolRequest({
      params: {
        name: this.name,
        email: this.email,
        school_type_id: this.schoolType?.id,
        city_id: this.city?.id,
        admin_name: this.adminName,
        admin_email: this.adminEmail,
        admin_phone: this.adminPhone,
        admin_position: this.adminPosition,
      },
      success: () => {
        this.name = "";
        this.email = "";
        this.schoolType = null;
        this.country = null;
        this.province = null;
        this.city = null;
        this.adminName = "";
        this.adminEmail = "";
        this.adminPhone = "";
        this.adminPosition = "";
        this.$bvModal.hide("modal-proposal");
      },
    });
  }
}
